import {
  AfterViewChecked,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation,
  ChangeDetectionStrategy
} from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { NGXLogger } from 'ngx-logger';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { ActionState } from 'src/app/enums/action-state.enum';
import { ColumnToNotDisplay } from 'src/app/enums/ColumnsToNotDisplay';
import { CoreEnum } from 'src/app/enums/core.enum';
import { TableTagListMapper } from 'src/app/mapper/table/table-tag-list.mapper';
import { DisplayText } from 'src/app/models/events/displayText';
import { EventColumn } from 'src/app/models/events/eventsColumn';
import { EventsUpdateTagGroup } from 'src/app/models/events/eventsUpdateTagGroup';
import { StationsRepo } from 'src/app/repositories/stations/repo/station-repo';
import { AlertService } from 'src/app/services';
import { TagSubjectComparaison } from 'src/app/shared/models/graph/tag-subject-comparaison.model';
import { AlertParameters, AlertType } from 'src/app/shared/models/models-index';
import { EventEmitterFilters } from 'src/app/shared/models/table/event-emitter-filters';
import FiltersConfig from 'src/app/shared/models/table/filters-config';
import { TagFilterType } from 'src/app/shared/models/tag/tag-filter-type';
import { IconType } from 'src/app/tinea-components/icon/enum/icon-type';
import { LinkClickSateType } from 'src/app/tinea-components/paging/enum/link-click-state-type';
import { PagingModel } from 'src/app/tinea-components/paging/models/input/paging-model';
import { TableModel } from 'src/app/tinea-components/table/models/input/table-model';
import { UiIcon } from 'src/app/tinea-components/table/models/input/ui-icon';
import { ColumnType } from 'src/app/tinea-components/tinea-table/models/columnType';
import { TableColumn } from 'src/app/tinea-components/tinea-table/models/tableColumn';
import { TableConfiguration } from 'src/app/tinea-components/tinea-table/models/tableConfiguration';
import {
  ConfiguredGraph,
  GraphConfigurationReferenceLine,
  GraphConfigurationTag,
  GraphConfigurationYAxis,
  GraphTagGroupList,
  GraphTagList,
  Station, TagInfos
} from 'src/swagger-gen/web-secured/models';
import { ModalColorTagGraphComponent } from '../../modal-color-tag-graph/modal-color-tag-graph.component';
import { MatDialog } from '@angular/material/dialog';
import { ModalReferenceLineGraphComponent } from '../modal-reference-line-graph/modal-reference-line-graph.component';


@Component({
    selector: 'app-selection-tag',
    templateUrl: './selection-tag.component.html',
    styleUrls: ['./selection-tag.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SelectionTagComponent
  implements OnInit, OnDestroy, OnChanges, AfterViewChecked {
    @Input() id: number; // index of station from list of 3
    @Input() columnsToNotDisplay: ColumnToNotDisplay;
    @Input() station: Station;
    @Input() creationMode: Boolean;
    @Input() getTagsSubj: Subject<any>;
    @Input() currentUnits: Array<string>;
    @Input() selectedTagsByDefault: string[] = []; // uid
    @Input() configuredGraphUpdate: ConfiguredGraph;
  
    @Output() getDataFromSelection = new EventEmitter<any>();
  
    @ViewChild('searchInput') searchInput: any;
  
    defaultGroup: DisplayText = new DisplayText('GROUP', 'Regroupement');
  
    maxUnits = CoreEnum.MAX_UNITS;
  
    selectedTags: TagInfos[];
    selectedTagsUid: Array<any> = [];
    selectedTagsConfigured: Array<GraphConfigurationTag> = [];
  
    yAxis: Array<GraphConfigurationYAxis> = [];
    referenceLines: Array<GraphConfigurationReferenceLine> = [];
  
    destroyed$ = new Subject<void>();
    eUid: string;
  
    loadingState = new BehaviorSubject('');
  
    errorMessage: string;
    actionState = ActionState;
  
    table: TableModel;
    paging: PagingModel;
    groupTableHeaders: any[];
  
    groupTableConfiguration: TableConfiguration;
  
    limitGroup = 50;
    offsetGroup = 0;
    offset = 0;
    limit = 50;
  
    dataForChildComponent: any = {};
    fullColumnList: any;
    isoldTableView: boolean;
  
    filtersConfig: FiltersConfig;
    hidefilterAll = true;
    groupKey: any;
  
    displayallUnselect: boolean;
  
    tagList: GraphTagList;
    tagGroupList: GraphTagGroupList;
    tagSubs: Subscription;
    tagGroupSubs: Subscription;
  
    preventCheckedLoop = 0;
  
    defaultTagsInterv: any;
  
    constructor(
      private stationRepo: StationsRepo,
      private translate: TranslateService,
      private logger: NGXLogger,
      private alertService: AlertService,
      private tableTagListMapper: TableTagListMapper,
      public dialog: MatDialog
    ) {
  
      this.groupTableHeaders = [
        new TableColumn(
          this.translate.instant('graphs.tag.' + TagFilterType.NAME),
          TagFilterType.NAME.toLowerCase(),
          '',
          'group-tag__' + TagFilterType.NAME,
          ColumnType.DATE,
          null,
          true
        ),
        new TableColumn(
          this.translate.instant('graphs.tag.' + TagFilterType.LAST_DATETIME),
          TagFilterType.LAST_DATETIME.toLowerCase(),
          '',
          'group-tag__' + TagFilterType.LAST_DATETIME,
          ColumnType.TEXT,
          null,
          true
        ),
        new TableColumn(
          this.translate.instant('graphs.tag.' + TagFilterType.LAST_VALUE_TAG),
          TagFilterType.LAST_VALUE_TAG.toLowerCase(),
          '',
          'group-tag__' + TagFilterType.LAST_VALUE_TAG,
          ColumnType.TEXT,
          null,
          true
        ),
        new TableColumn(
          this.translate.instant('graphs.tag.' + TagFilterType.UNIT),
          TagFilterType.UNIT.toLowerCase(),
          '',
          'group-tag__' + TagFilterType.UNIT,
          ColumnType.TEXT,
          null,
          true
        ),
        new TableColumn(
          this.translate.instant('graphs.tag.' + TagFilterType.LOW_THRESHOLD),
          TagFilterType.LOW_THRESHOLD.toLowerCase(),
          '',
          'group-tag__' + TagFilterType.LOW_THRESHOLD,
          ColumnType.TEXT,
          null,
          true
        ),
        new TableColumn(
          this.translate.instant('graphs.tag.' + TagFilterType.HIGH_THRESHOLD),
          TagFilterType.HIGH_THRESHOLD.toLowerCase(),
          '',
          'group-tag__' + TagFilterType.HIGH_THRESHOLD,
          ColumnType.TEXT,
          null,
          true
        ),
        new TableColumn(
          this.translate.instant('graphs.tag.' + TagFilterType.VALUE_TYPE),
          TagFilterType.VALUE_TYPE.toLowerCase(),
          '',
          'group-tag__' + TagFilterType.VALUE_TYPE,
          ColumnType.TEXT,
          null,
          true
        ),
        new TableColumn(
          this.translate.instant('graphs.tag.' + TagFilterType.ACTION),
          TagFilterType.ACTION.toLowerCase(),
          '',
          'group-tag__' + TagFilterType.ACTION,
          ColumnType.TEXT,
          null,
          true
        ),
      ];
  
      this.fullColumnList = [
        new EventColumn(
          true,
          new DisplayText(
            TagFilterType.NAME,
            this.translate.instant('graphs.tag.' + TagFilterType.NAME)
          )
        ),
        new EventColumn(
          true,
          new DisplayText(
            TagFilterType.LAST_DATETIME,
            this.translate.instant('graphs.tag.' + TagFilterType.LAST_DATETIME)
          )
        ),
        new EventColumn(
          true,
          new DisplayText(
            TagFilterType.LAST_VALUE_TAG,
            this.translate.instant('graphs.tag.' + TagFilterType.LAST_VALUE_TAG)
          )
        ),
        new EventColumn(
          true,
          new DisplayText(
            TagFilterType.UNIT,
            this.translate.instant('graphs.tag.' + TagFilterType.UNIT)
          )
        ),
        new EventColumn(
          true,
          new DisplayText(
            TagFilterType.HIGH_THRESHOLD,
            this.translate.instant('graphs.tag.' + TagFilterType.HIGH_THRESHOLD)
          )
        ),
        new EventColumn(
          true,
          new DisplayText(
            TagFilterType.LOW_THRESHOLD,
            this.translate.instant('graphs.tag.' + TagFilterType.LOW_THRESHOLD)
          )
        ),
        new EventColumn(
          true,
          new DisplayText(
            TagFilterType.VALUE_TYPE,
            this.translate.instant('graphs.tag.' + TagFilterType.VALUE_TYPE)
          )
        ),
        new EventColumn(
          true,
          new DisplayText(
            TagFilterType.GROUP,
            this.translate.instant('graphs.tag.' + TagFilterType.GROUP)
          )
        ),
        new EventColumn(
          true,
          new DisplayText(
            TagFilterType.ACTION,
            this.translate.instant('graphs.tag.' + TagFilterType.ACTION)
          )
        ),
      ];
      this.groupTableConfiguration = new TableConfiguration(
        'shiva-table',
        'table',
        false
      );
      this.groupTableConfiguration.withSelect = false;
      this.groupTableConfiguration.withMore = false;
      this.groupTableConfiguration.withIntegratedComponent = true;
    }
  
    ngOnInit(): void {
      this.groupTableHeaders.forEach(x => {
        const header: TableColumn = x;
        if (header.propertyName == TagFilterType.HIGH_THRESHOLD.toLowerCase() || header.propertyName == TagFilterType.LOW_THRESHOLD.toLowerCase()) {
          header.displayed = (this.columnsToNotDisplay != ColumnToNotDisplay.NotDisplay);
        }
      });
  
  
      this.eUid = this.station.uid;
      this.getTags();
      this.getTagsSubj
        .pipe(takeUntil(this.destroyed$))
        .subscribe((data: TagSubjectComparaison) => {
          // From graph comparison
          if (data && data.uid && this.id === data.index) {
            if (this.eUid !== data.uid) {
              this.eUid = data.uid;
              this.getTags();
            } else {
              this.getTags();
            }
          } else {
            // From station graph
            return;
          }
        });
  
      this.filtersConfig = {
        column: {
          fullColumnList: this.fullColumnList,
        },
        sort: {
          paramsToInclude: [TagFilterType.NAME],
          defaultSort: TagFilterType.NAME,
        },
        group: {
          paramsToInclude: [TagFilterType.GROUP],
        },
        search: {
          paramsToInclude: [TagFilterType.NAME],
        },
      };
  
      this.displayallUnselect = true;
  
  
      if(this.configuredGraphUpdate) { 
        this.yAxis = this.configuredGraphUpdate.configuration.configurationYAxis; 
        if(this.configuredGraphUpdate.configuration.configurationReferenceLine) { 
          this.referenceLines = this.configuredGraphUpdate.configuration.configurationReferenceLine; 
        } 
        this.selectedTagsConfigured = this.configuredGraphUpdate.configuration.tags; 
      }
    }
  
    /**
     * Receive events from Filter component
     * @param event event type
     */
    eventReceiver(event: any) {
      const typeEvent = event.type;
      const dataEvent = event.data;
      switch (typeEvent) {
        case EventEmitterFilters.PARAMS:
          this.getParamsForGetTags(dataEvent);
          break;
        case EventEmitterFilters.BODY:
          this.getBodyForGetTags(dataEvent);
          break;
        case EventEmitterFilters.SHOW_HIDE_COLUMN:
          this.addRemoveColumnItem(dataEvent);
          break;
        default:
          return;
      }
    }
  
    ngAfterViewChecked() {
      if(!this.creationMode) {
      // For List View
      if (this.groupTableConfiguration.detailComponent === 'tag') {
        if (this.preventCheckedLoop === 0) {
          this.checkSelectedTags(false);
          if (this.currentUnits) {
            this.checkForDisableTag(this.currentUnits.length);
          }
        }
      }
      // For Group View
      if (this.groupTableConfiguration.detailComponent === 'tag-group') {
        if (this.preventCheckedLoop !== null && this.preventCheckedLoop !== 0) {
          this.checkSelectedTags(true);
        }
      }
      }
    }
  
    /**
     * Check all already selected tags
     */
    checkSelectedTags(groupEnabled: boolean) {
      this.preventCheckedLoop += 1;
      setTimeout(() => {
  
        const tags = document.querySelectorAll(
          '.selection-tag-index-' + this.id + ' td[data-column_id="ACTION"] .wrap-value-cell'
        );
        const tagsGroup = document.querySelectorAll(
          '.selection-tag-index-' + this.id + ' .group-cell__action'
        );
        if (tags.length > 0) {
          tags.forEach((tag) => {
  
            const tagUid = tag.classList[2];
            const index = this.selectedTagsUid.indexOf(tagUid);
  
            if (index === -1) {
              tag.classList.remove('tag--selected');
            } else {
              tag.classList.add('tag--selected');
            }
          });
        }
        if (tagsGroup.length > 0) {
          tags.forEach((tag) => {
  
            const tagUid = tag.classList[0];
  
            const index = this.selectedTagsUid.indexOf(tagUid);
  
            if (index === -1) {
              tag.classList.remove('tag--selected');
            } else {
              tag.classList.add('tag--selected');
            }
          });
        }
      }, 1000);
    }
  
    /**
     * Disable tags when units reach MAX
     */
    ngOnChanges(changes: SimpleChanges) {
      if (changes?.currentUnits?.currentValue) {
        this.checkForDisableTag(changes.currentUnits.currentValue.length);
      }
  
      if (changes?.selectedTagsByDefault?.currentValue) {
        const uidList = changes?.selectedTagsByDefault?.currentValue;
        this.selectedByDefault(uidList);
      }
    }
  
    checkForDisableTag(currentNbUnits: number): void {
      const allTags = document.querySelectorAll(
        `td[data-column_id="ACTION"] .wrap-value-cell, .group-cell__action`
      );
      if (currentNbUnits === this.maxUnits) {
        Array.from(allTags).forEach((tag) => {
          const attrUnit = tag.getAttribute('data-id') !== null ? tag.getAttribute('data-id') : '';
          if (!this.currentUnits.includes(attrUnit)) {
            tag.classList.add('disabled');
          }
        });
      } else {
        Array.from(allTags).forEach((tag) => {
          tag.classList.remove('disabled');
        });
      }
    }
  
    getTags() {
      this.loadingState.next(ActionState.LOADING);
      this.isoldTableView = false;
      const params = this.dataForChildComponent.params;
      const body = this.dataForChildComponent.body;
  
      if (!params || !body) {
        return;
      }
  
      if (this.tagSubs) {
        this.tagSubs.unsubscribe();
      }
  
      this.tagSubs = this.stationRepo
        .getStationTags(this.eUid, this.offset, this.limit, params, body)
        .subscribe({
          next: (res: GraphTagList) => {
            this.loadingState.next(ActionState.READY);
            this.tagList = res;
            this.createTableMapping();
            this.createPagingMapping();
            this.preventCheckedLoop = 0;
          },
          error: (error) => {
            this.showAlert(error);
            this.loadingState.next(ActionState.READY);
          },
        });
    }
  
  
    getTagsGroup() {
      this.isoldTableView = true;
      this.loadingState.next(ActionState.LOADING);
      const params = this.dataForChildComponent.params;
      const body = this.dataForChildComponent.body;
  
      if (this.tagGroupSubs) {
        this.tagGroupSubs.unsubscribe();
      }
  
      this.dataForChildComponent.siteId = this.eUid;
      this.dataForChildComponent.groupName = this.groupKey;
  
      this.tagGroupSubs = this.stationRepo
        .getStationGroupedTags(
          this.eUid,
          this.offsetGroup,
          this.limitGroup,
          params,
          body
        )
        .subscribe({
          next: (res: GraphTagGroupList) => {
            this.tagGroupList = res;
            if (!this.tagGroupList.list) {
              this.tagGroupList.list = [];
            }
  
            /* Get rid of duplicates (summing their totals) */
            const reducedList = this.tagGroupList.list.reduce((p, c) => {
              const duplicate = p.find((ev) => ev.name === c.name);
              if (!!duplicate) {
                p[p.indexOf(duplicate)].total += c.total;
              } else {
                p.push(c);
              }
              return p;
            }, []);
  
            this.tagGroupList.list = reducedList;
            this.loadingState.next(ActionState.READY);
            this.preventCheckedLoop = 0;
          },
          error: (error) => {
            this.showAlert(error);
            this.loadingState.next(ActionState.READY);
          },
        });
    }
    /***************************************  TABLE MAPPING  **********************************/
    createTableMapping() {
      const table: TableModel = this.tableTagListMapper.init(this.tagList, this.columnsToNotDisplay);
      this.table = table;
    }
  
    createPagingMapping() {
      this.paging = this.generatePaging();
    }
  
    generatePaging(): PagingModel {
      const paging = new PagingModel(
        this.tagList.paging.offset,
        this.limit,
        this.tagList.paging.curItems,
        this.tagList.paging.totalItems,
        this.tagList.paging.nextItemsLink,
        this.tagList.paging.previousItemsLink
      );
  
      // configuration
      paging.configuration.actionIfNoLink = 'disabled';
      paging.configuration.pagingEnabled = false;
      paging.configuration.rangeEnabled = true;
      // prevLink
      const prevLinkElement = new UiIcon();
      prevLinkElement.type = IconType.FONTAWESOME;
      prevLinkElement.value = 'icon-arrow-left-circle';
      paging.configuration.prevLinkElement = prevLinkElement;
      // nextLink
      const nextLinkElement = new UiIcon();
      nextLinkElement.type = IconType.FONTAWESOME;
      nextLinkElement.value = 'icon-arrow-right-circle';
      paging.configuration.nextLinkElement = nextLinkElement;
  
      return paging;
    }
  
    getParamsForGetTags(event: any): void {
      this.dataForChildComponent.params = event;
      event.forEach(
        (p) => (this.groupKey = p.key === 'groupName' ? p.value : null)
      );
      this.toggleGroupView(this.groupKey);
    }
  
    getBodyForGetTags(event: any): void {
      this.dataForChildComponent.body = event;
      this.toggleGroupView(this.groupKey);
    }
  
    addRemoveColumnItem(event: any): void {
      const columnKey = event.columnKey;
      const show = event.show;
      this.table.dataRow.forEach((r) => {
        r.cells.forEach((c) => {
          this.showOrHideCell(c, columnKey, show);
        });
      });
      this.addRemoveColumnToTableHeader(columnKey, show);
    }
  
    addRemoveColumnToTableHeader(columnKey: string, show: boolean) {
      this.table.header.cells.forEach((c) => {
        this.showOrHideCell(c, columnKey, show);
      });
    }
  
    showOrHideCell(c: any, columnKey: string, show: boolean) {
      const types = TagFilterType.values();
      types.forEach((type) => {
        if (columnKey === type && c.columnId === type) {
          c.show = show;
        }
      });
    }
  
    toggleGroupView(event: any): void {
      this.groupKey = event;
      this.loadingState.next(ActionState.LOADING);
      this.offset = 0;
      this.offsetGroup = 0;
      if (!this.groupKey) {
        this.goDefaultViewTable();
      } else {
        this.goTableViewByGroup();
      }
    }
  
    goDefaultViewTable(): void {
      this.groupTableConfiguration.detailComponent = 'tag';
      this.getTags();
    }
  
    goTableViewByGroup(): void {
      this.groupTableConfiguration.detailComponent = 'tag-group';
      this.getTagsGroup();
    }
  
    /**
     * Check / uncheck tag
     */
    onEventOnClick(event: any) {
      if (event instanceof EventsUpdateTagGroup) {
        if (event.hasGetNewListOfGroup) {
          this.checkForDisableTag(this.currentUnits.length);
          this.selectedByDefaultOnClickGroup();
          this.preventCheckedLoop = null;
        }
      } else if (event.uid) {
        if(this.creationMode) {
          const index = this.selectedTagsUid.indexOf(event.uid);
          if(index == -1) {
            this.openModalColorTag(event);
          } else {
            
            this.addRemoveTagOnChart(event.uid, true, event);
          }
        } else {
          this.addRemoveTagOnChart(event.uid, true);
        }
        // Prevent ngOnCheck on unnessarry action on Group View
        this.preventCheckedLoop = null;
      } else {
        return;
      }
    }
  
    openModalColorTag(tag: TagInfos) {
      const dialogRef = this.dialog.open(ModalColorTagGraphComponent, {
        data: {tag: tag, yAxis: this.yAxis},
        disableClose: true,
        width: "600px",
        height: "800px",
      });
  
      if (dialogRef) {
        dialogRef.afterClosed().subscribe((result: any) => {
          if(result.yAxis) {
            this.yAxis.push(result.yAxis);
          }
          if(result.configuredTag) {
            this.addRemoveTagOnChart(result.configuredTag.uid, true, result.configuredTag);
          }
        });
      }
    }
  
    openModalReferenceLine() {
      const dialogRef = this.dialog.open(ModalReferenceLineGraphComponent, {
        data: {yAxis: this.yAxis },
        disableClose: true,
        width: "600px",
      });
  
      if (dialogRef) {
        dialogRef.afterClosed().subscribe((result: any) => {
          if(result.referenceLine) {
            const index = this.referenceLines.findIndex((ref) => (ref.name === result.referenceLine.name));
            if(index === -1) {
              this.referenceLines.push(result.referenceLine);
            }
  
            this.getDataFromSelection.next({
              list: this.selectedTagsUid,
              listConfigured: this.selectedTagsConfigured,
              yAxis: this.yAxis,
              referenceLines: this.referenceLines,
              station: this.station,
            });
          }
        });
      }
    }
  
    removeRefLine(index: number) {
      this.referenceLines.splice(index,1);
      this.getDataFromSelection.next({
        list: this.selectedTagsUid,
        listConfigured: this.selectedTagsConfigured,
        yAxis: this.yAxis,
        referenceLines: this.referenceLines,
        station: this.station,
      });
      
    }
  
    selectedByDefault(list: string[]): void {
      clearInterval(this.defaultTagsInterv);
      if (list.length > 0) {
        // verifier que l'élément existe dans le dom
        this.defaultTagsInterv = setInterval(() => {
          const targetTag = document.getElementsByClassName(`${list[0]}`)[0];
          if (targetTag) {
            clearInterval(this.defaultTagsInterv);
  
            // this.preventCheckedLoop = null;
            list.forEach(l => {
              this.addRemoveTagOnChart(l, false);
            });
          }
        }, 100);
  
      }
    }
  
    selectedByDefaultOnClickGroup(): void {

      this.selectedTagsUid = this.selectedTagsUid.filter(s => !this.selectedTagsByDefault.includes(s));
  
      this.selectedByDefault(this.selectedTagsByDefault);
    }
  
  
    resetDataFormSelect() {
      this.getDataFromSelection.next({
        list: [],
        listConfigured: [],
        station: this.station,
      });
    }
  
    removeDuplicates(data: any): any {
      const unique = [];
  
      data.forEach(element => {
        if (!unique.includes(element)) {
          unique.push(element);
        }
      });
      return unique;
    }
  
    unSelectedAll() {
      this.selectedTagsUid =  this.removeDuplicates(this.selectedTagsUid.slice());
      let unselectAll = this.selectedTagsUid.slice();
      unselectAll =  this.removeDuplicates(unselectAll);
      this.selectedTagsConfigured = [];
      for (let i = 0; i <= unselectAll.length ; i++) {
        this.addRemoveTagOnChart(unselectAll[i], this.selectedTagsUid.length === 1);
      }
    }
  
    addRemoveTagOnChart(tagUid: string, executeDataFromSelect: boolean, configuredTag?: GraphConfigurationTag) {
      const index = this.selectedTagsUid.indexOf(tagUid);
      let indexCondigured;
      const targetTag = document.getElementsByClassName(`${tagUid}`);
  
      // Add/remove tag from selectedTagsConfigured
      if(configuredTag) {
        indexCondigured = this.selectedTagsConfigured.findIndex((tag) => (tag.uid == configuredTag.uid))
        if (indexCondigured !== -1) {
          // Remove Yaxis if only one tag use this Yaxis
          const duplicatesExist = this.selectedTagsConfigured.filter((elem) => {
            return elem.yAxis === this.selectedTagsConfigured[indexCondigured].yAxis;
          });
  
          if(duplicatesExist.length === 1) {
            // Remove reference lines when remove Y axis
            const index = this.yAxis.findIndex((elem) => (elem.index == this.selectedTagsConfigured[indexCondigured].yAxis))
            this.referenceLines = this.referenceLines.filter(elem => elem.yAxis !== this.selectedTagsConfigured[indexCondigured].yAxis);
            this.yAxis.splice(index, 1);
  
            
          }
          this.selectedTagsConfigured.splice(indexCondigured, 1);
        } else {
          this.selectedTagsConfigured.push(configuredTag);
        }
      }
  
  
      // add/remove tag from selectedTags - separated to avoid duplicate tags in selectedTags
      if (index !== -1) {
        this.selectedTagsUid.splice(index, 1);
      } else {
        this.selectedTagsUid.push(tagUid);
      }
  
      // add/remove checbox selections for all duplicates
      for (let i = 0; i < targetTag.length; i++) {
        if (targetTag !== undefined) {
          if (targetTag[i].classList.contains('disabled')) {
            return;
          }
          if (index !== -1) {
            targetTag[i].classList.remove('tag--selected');
            this.selectedTagsByDefault = this.selectedTagsByDefault.filter(s => s !== tagUid);
          } else {
            targetTag[i].classList.add('tag--selected');
  
            if (!this.selectedTagsByDefault.includes(tagUid)) {
              this.selectedTagsByDefault.push(tagUid);
            }
          }
        }
      }
      if (executeDataFromSelect) {
        if(this.selectedTagsConfigured.length > 0 && this.selectedTagsConfigured.length != this.selectedTagsUid.length) {
          this.selectedTagsUid = this.selectedTagsConfigured.map(obj => obj.uid);
        }
        this.getDataFromSelection.next({
          list: this.selectedTagsUid,
          listConfigured: this.selectedTagsConfigured,
          yAxis: this.yAxis,
          referenceLines: this.referenceLines,
          station: this.station,
        });
      }
    }
  
    // TODO: refacto to Paging Component
    onPagination(type: 'next' | 'prev' | 'next-event' | 'prev-event') {
      if (type === 'next') {
        this.onNextPaginationGroup();
      } else if (type === 'prev') {
        this.onPrevPaginationGroup();
      } else if (type === 'next-event') {
        this.onNextPaginationEvent();
      } else if (type === 'prev-event') {
        this.onPrevPaginationEvent();
      }
    }
  
    onPrevPaginationGroup() {
      this.offsetGroup = this.offsetGroup - this.limitGroup;
      this.getTagsGroup();
    }
  
    onNextPaginationGroup() {
      this.offsetGroup = this.offsetGroup + this.limitGroup;
      this.getTagsGroup();
    }
  
    onPrevPaginationEvent() {
      this.offset = this.offset - this.limit;
      this.getTags();
    }
  
    onNextPaginationEvent() {
      this.offset = this.offset + this.limit;
      this.getTags();
    }
  
    eventOnClickPrevLink(event: LinkClickSateType): void {
      if (event === LinkClickSateType.ALLOWED) {
        this.onPagination('prev-event');
      }
    }
  
    eventOnClickNextLink(event: LinkClickSateType): void {
      if (event === LinkClickSateType.ALLOWED) {
        this.onPagination('next-event');
      }
    }
  
    showAlert(error: any) {
      const title = this.translate.instant('error.title');
      const alertParams = new AlertParameters(
        false,
        false,
        true,
        false,
        false,
        false,
        true,
        title
      );
      this.alertService.showAlert(error, AlertType.ERROR, alertParams);
    }
  
    ngOnDestroy() {
      clearInterval(this.defaultTagsInterv);
      const subscriptions = [this.tagSubs, this.tagGroupSubs];
      subscriptions.forEach((sub) => {
        if (sub) {
          sub.unsubscribe();
        }
      });
    }
}
